// 用户信息
export const TokenKeys = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  SESSION_TOKEN: 'session_token',
  SESSION_TIME:10*60*60*1000,
  SOCKET_TIME:60*60*1000,
  LANGUAGE:'language'
};
export const canvasType={
  PNG: 'png',
  JPG: 'jpg'
};



// WEBPACK FOOTER //
// ./src/util/variable.js